import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { useTranslation } from "react-i18next";

const ReturnRefundPolicyPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="font-sans">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center gap-4">
          <button
            onClick={() => navigate(-1)}
            className="text-gray-600 transition-colors"
            aria-label="Go back"
          >
            <ChevronLeft className="w-6 h-6 relative mb-[2px]" />
          </button>
          <h1 className="text-xl font-bold">{t("refundPage.title")}</h1>
        </div>
      </header>

      {/* Content */}
      <div className="bg-white dark:bg-transparent max-w-2xl mx-auto px-4 py-6 space-y-6 text-gray-700 dark:text-gray-300">
        <p className="text-xs text-gray-500 dark:text-gray-400">{t("refundPage.lastUpdated")}</p>
        <p>{t("refundPage.intro")}</p>

        <Section title={t("refundPage.s1Title")}>
          <p>{t("refundPage.s1Lead")}</p>
          <ul className="list-disc pl-5 space-y-1 mt-2">
            <li>{t("refundPage.s1Item1")}</li>
            <li>{t("refundPage.s1Item2")}</li>
            <li>{t("refundPage.s1Item3")}</li>
          </ul>
          <p className="mt-2 text-yellow-700 dark:text-yellow-400 font-medium">{t("refundPage.s1Warning")}</p>
        </Section>

        <Section title={t("refundPage.s2Title")}>
          <p>{t("refundPage.s2Lead")}</p>
          <ul className="list-disc pl-5 space-y-1 mt-2">
            <li>{t("refundPage.s2Item1")}</li>
            <li>{t("refundPage.s2Item2")}</li>
            <li>{t("refundPage.s2Item3")}</li>
            <li>{t("refundPage.s2Item4")}</li>
          </ul>
        </Section>

        <Section title={t("refundPage.s3Title")}>
          <p>{t("refundPage.s3Lead")}</p>
          <ol className="list-decimal pl-5 space-y-1 mt-2">
            <li>{t("refundPage.s3Step1")}</li>
            <li>{t("refundPage.s3Step2")}</li>
            <li>{t("refundPage.s3Step3")}</li>
            <li>{t("refundPage.s3Step4")}</li>
            <li>{t("refundPage.s3Step5")}</li>
          </ol>
          <p className="mt-2 text-gray-500 dark:text-gray-400">{t("refundPage.s3Footer")}</p>
        </Section>

        <Section title={t("refundPage.s4Title")}>
          <p>{t("refundPage.s4Lead")}</p>
          <ul className="list-disc pl-5 space-y-1 mt-2">
            <li>{t("refundPage.s4Item1")}</li>
            <li>
              {t("refundPage.s4Item2")}
              <ul className="list-disc pl-5 mt-1 space-y-1">
                <li>{t("refundPage.s4Item2a")}</li>
                <li>{t("refundPage.s4Item2b")}</li>
              </ul>
            </li>
          </ul>
        </Section>

        <Section title={t("refundPage.s5Title")}>
          <ul className="list-disc pl-5 space-y-1">
            <li>{t("refundPage.s5Item1")}</li>
            <li>{t("refundPage.s5Item2")}</li>
          </ul>
          <p className="mt-2 text-yellow-700 dark:text-yellow-400 font-medium">{t("refundPage.s5Warning")}</p>
          <ul className="list-disc pl-5 space-y-1 mt-1">
            <li>{t("refundPage.s5Item1")}</li>
            <li>{t("refundPage.s5Item2")}</li>
          </ul>
        </Section>

        <Section title={t("refundPage.s6Title")}>
          <ul className="list-disc pl-5 space-y-1">
            <li>{t("refundPage.s6Item1")}</li>
            <li>{t("refundPage.s6Item2")}</li>
            <li>{t("refundPage.s6Item3")}</li>
          </ul>
        </Section>

        <Section title={t("refundPage.s7Title")}>
          <p>{t("refundPage.s7Lead")}</p>
          <ul className="list-disc pl-5 space-y-1 mt-2">
            <li>{t("refundPage.s7Item1")}</li>
            <li>{t("refundPage.s7Item2")}</li>
          </ul>
        </Section>

        <Section title={t("refundPage.s8Title")}>
          <p>{t("refundPage.s8Lead")}</p>
          <p className="mt-1">
            {t("refundPage.s8Email")}{" "}
            <a href="mailto:support@worldcreatorventures.com" className="text-primary-100 underline">
              support@worldcreatorventures.com
            </a>
          </p>
        </Section>

        <Section title={t("refundPage.s9Title")}>
          <ul className="list-disc pl-5 space-y-1">
            <li>{t("refundPage.s9Item1")}</li>
            <li>{t("refundPage.s9Item2")}</li>
            <li>{t("refundPage.s9Item3")}</li>
          </ul>
        </Section>
      
      </div>
    </div>
  );
};

const Section = ({ title, children }) => (
  <div>
    <h2 className="text-base font-semibold text-gray-900 dark:text-white mb-2">{title}</h2>
    <div className="text-sm space-y-1">{children}</div>
  </div>
);

export default ReturnRefundPolicyPage;
